import { useState, useEffect } from "react";
import { useLang } from "@/i18n/LangContext";
import { Link } from "react-router-dom";

export default function CookieConsent() {
  const { t } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("pink_cookies");
    if (!accepted) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("pink_cookies", "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[90] p-4" data-testid="cookie-consent-banner">
      <div className="max-w-4xl mx-auto bg-[#0a0a0a]/95 backdrop-blur-md border border-white/10 rounded-xl px-6 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4 shadow-lg">
        <p className="text-sm text-neutral-300 flex-1">
          {t("cookie_banner")}{" "}
          <Link to="/cookie-policy" className="text-purple-400 hover:text-purple-300 underline underline-offset-2" data-testid="cookie-policy-link">
            {t("cookie_policy_link")}
          </Link>
        </p>
        <button
          onClick={accept}
          className="shrink-0 px-6 py-2.5 bg-purple-600 hover:bg-purple-500 text-white text-xs font-bold uppercase tracking-widest rounded-lg border border-purple-400 transition-all duration-300"
          data-testid="cookie-accept-btn"
        >
          {t("cookie_accept")}
        </button>
      </div>
    </div>
  );
}
